<template>
  <div id="search-by-keyword" v-cloak>
    <div id="searchbar">
      <input type="text" v-model="searchKey" placeholder="Search">
      <i class="fas fa-search"></i>
    </div>
    <div v-if='!showCollege && !searchKey' id="college-majors" ref='collegePlaceholder'>
      <h1>All {{ programNaming }}{{ majors.length > 1 ? 's' : '' }}</h1>
      <h4>{{ majors.length }} {{ programNaming }}{{ majors.length > 1 ? 's' : '' }}</h4>
    </div>
    <major-list :majors="filteredMajors"></major-list>
  </div>
</template>

<script>
  import MajorList from '../components/major_list'

  export default {
    name: 'KeywordSearch',

    data() {
      return {
        // searchKey: ''
        // majors: []
      }
    },

    mounted() {
      this.$store.commit('setCurrentView', 'keywordSearchView')
    },

    computed: {
      searchKey: {
        get() {
          return this.$route.query.keyword
        },

        set(keyword) {
          this.$router.replace({
            name: 'nameSearch',
            query: {keyword: keyword}
          })
        }
      },

      // Filters majors based on their name and the search key
      filteredMajors() {
        let searchRegex = new RegExp(this.searchKey, 'i')
        return this.majors.filter((major) => {
          return searchRegex.test((major.program || {}).name) ||
                 searchRegex.test((major.program || {}).code) ||
                 searchRegex.test((major.concentration || {}).name) ||
                 searchRegex.test((major.concentration || {}).code)
        })
      },

      majors() {
        if (process.env.SHOW_COLLEGE) {
          return this.$store.getters.currentMajors
        }
        return this.$store.getters.currentUniqueMajors
      },

      showCollege() {
        return process.env.SHOW_COLLEGE
      },

      programNaming() {
        return process.env.PROGRAM_NAMING
      }
    },

    components: {
      'major-list': MajorList
    }
  }
</script>



// WEBPACK FOOTER //
// KeywordSearch.vue?260a9824